import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { USER_API } from "../../common/common";
import { Logout, showTvIcon, getImageUrl } from "../../common/Funcation";
import Loader from "../../components/Loader";
import CheckResults from "./CheckResults";
import { notifyError, notifyMessage, postApi, sendEvent } from "../../service";
import LoaderImage from "../../assets/images/loaderajaxbet1.gif";
import CricketImage from "../../assets/images/cricket-m.jpeg";

export interface gameInterface {
  back1: number;
  back2: number;
  back3: number;
  eid: number;
  eventName: string;
  f: boolean;
  gameId: number;
  ifb: boolean;
  inPlay: boolean;
  lay1: number;
  lay2: number;
  lay3: number;
  m1: boolean;
  marketId: string;
  openDate: string;
  p: boolean;
  pin: boolean;
  _id: string;
  ematch: number;
  tv_status?: string | number;
  score1?: number | string;
  score2?: number | string;
}

const eventTitleWithScore = (item: gameInterface, sportDetails?: any) => {
  const match = sportDetails?.res?.find(
    (s: any) => String(s.gameId) === String(item.gameId)
  );
  const score1 = match?.score1 ?? item.score1;
  const score2 = match?.score2 ?? item.score2;
  const inPlay = item.inPlay || match?.inPlay;
  const hasScore =
    inPlay &&
    score1 != null &&
    score2 != null &&
    score1 !== "" &&
    score2 !== "";
  if (!hasScore) return item.eventName;
  const spacer = window.innerWidth > 993 ? "\u00A0\u00A0" : "";
  return `${item.eventName}${spacer}(${score1}) - (${score2})`;
};

const cookies = new Cookies();

const globalTabDataCache: any = {};

const Inplay = () => {
  const navigate = useNavigate();
  const openMatchOdds = (item: gameInterface, e?: React.MouseEvent) => {
    e?.preventDefault();
    localStorage.setItem("sportsName", item.eventName);
    localStorage.setItem("sportsData", JSON.stringify(item));
    sendEvent("GET_SPORTS_DETAILS", {
      eventId: item.gameId,
      marketId: item.marketId,
      domain: window.location.hostname,
    });
    navigate(`/multimarket/${item.gameId}/${item.marketId}`);
  };
  const DD = useSelector((e: any) => e.domainDetails);
  const soccerSport = useSelector((e: any) => e.soccer);
  const tennisSport = useSelector((e: any) => e.tennis);
  const eventTypeColor = String(DD?.mobileEventTypeSchema || "")
    .trim()
    .replace(/;+\s*$/, "");
  const eventTypeTextColor = String(DD?.mobileEventTypeTextColor || "")
    .trim()
    .replace(/;+\s*$/, "");
  const eventTypeWrapStyle =
    eventTypeColor || eventTypeTextColor
      ? ({
          ...(eventTypeColor
            ? { ["--mobile-event-type-bg" as any]: eventTypeColor }
            : {}),
          ...(eventTypeTextColor
            ? { ["--mobile-event-type-color" as any]: eventTypeTextColor }
            : {}),
        } as React.CSSProperties)
      : undefined;
  const showInplayCricketBanner = DD?.inplayCricketBanner !== false;
  const inplayCricketBannerSrc = String(DD?.inplayCricketBannerImage || "").trim()
    ? getImageUrl(DD.inplayCricketBannerImage)
    : CricketImage;
  const [pageData, setPageData] = useState<any>({});
  const [tab, setTab] = useState("play");
  const activeTabRef = useRef("play");
  const [cricketToggle, setCricketToggle] = useState(false);
  const [soccerToggle, setSoccerToggle] = useState(false);
  const [tennisToggle, setTennisToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState({
    cricket: true,
    soccer: true,
    tennis: true,
  });
  const [tempFilter, setTempFilter] = useState({
    cricket: true,
    soccer: true,
    tennis: true,
  });

  const isAllTempChecked =
    tempFilter.cricket && tempFilter.soccer && tempFilter.tennis;
  const tempActiveCount =
    (tempFilter.cricket ? 1 : 0) +
    (tempFilter.soccer ? 1 : 0) +
    (tempFilter.tennis ? 1 : 0);

  const toggleFilterOpen = () => {
    if (!filterOpen) {
      setTempFilter(activeFilter);
    }
    setFilterOpen(!filterOpen);
  };

  const handleSelectAll = () => {
    setTempFilter({
      cricket: true,
      soccer: true,
      tennis: true,
    });
  };

  const handleSaveFilter = () => {
    setActiveFilter(tempFilter);
    setFilterOpen(false);
  };

  const handleCancelFilter = () => {
    setTempFilter(activeFilter);
    setFilterOpen(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      sendEvent("GET_SPORTS", { type: "soccer" });
      sendEvent("GET_SPORTS", { type: "tennis" });
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    activeTabRef.current = tab;
    if (tab === "Result") {
      setIsLoading(false);
      return;
    }
    // Show cached data instantly if available, fetch fresh in background
    if (globalTabDataCache[tab]) {
      setPageData(globalTabDataCache[tab]);
    } else {
      setIsLoading(true);
    }
    getPageData(tab);
  }, [tab]);

  // Pre-fetch other tabs after initial load
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!globalTabDataCache["today"]) getPageData("today", true);
      if (!globalTabDataCache["tomorrow"]) getPageData("tomorrow", true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const getPageData = async (FILTER: string, silent: boolean = false) => {
    let data = {
      api: USER_API.IN_PLAY,
      value: { filter: FILTER, userId: cookies.get("skyTokenFront") ? "" : "" },
    };

    await postApi(data)
      .then(function (response) {
        const freshData = response.data.data;
        globalTabDataCache[FILTER] = freshData;
        if (FILTER === activeTabRef.current) {
          setPageData(freshData);
          if (!silent) setIsLoading(false);
        }
      })
      .catch((err) => {
        if (!silent && FILTER === activeTabRef.current) setIsLoading(false);
        if (err.response?.data?.statusCode === 401) {
          Logout();
        }
      });
  };

  const getPageDataRef = useRef(getPageData);
  getPageDataRef.current = getPageData;

  useEffect(() => {
    const timer = setInterval(() => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") {
        return;
      }
      const current = activeTabRef.current;
      if (!current || current === "Result") return;
      getPageDataRef.current(current, true);
    }, 10000);
    return () => clearInterval(timer);
  }, []);

  const pinMetch = async (e: any, item: gameInterface, type: string) => {
    if (cookies.get("skyTokenFront")) {
      let data = {
        api: USER_API.PIN,
        value: {
          sportId: item._id,
          type: type,
          flag: !item.pin,
        },
      };

      await postApi(data)
        .then(function (response) {
          // setIsLoading(true)
          console.log("Pin match response: ", response);
          getPageData(tab);
          notifyMessage("Pin Success");
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.statusCode === 401) {
            Logout();
            notifyError("Pin unsuccess");
            // navigate('/login')
          }
        });
    } else {
      notifyError("please login first");
    }
  };

  const changeTab = (TAB: string) => {
    if (TAB === "Result") {
      setIsLoading(false);
      setPageData({});
    } else if (globalTabDataCache[TAB]) {
      setPageData(globalTabDataCache[TAB]);
    } else {
      setPageData({});
    }
    setTab(TAB);
    setCricketToggle(false);
    setSoccerToggle(false);
    setTennisToggle(false);
    setActiveFilter({ cricket: true, soccer: true, tennis: true });
    setTempFilter({ cricket: true, soccer: true, tennis: true });
    setFilterOpen(false);
  };

  return (
    <>
      <div className="full-wrap">
        <div
          className={`inplay_left col-center${eventTypeColor ? " has-event-type-color" : ""}${eventTypeTextColor ? " has-event-type-text" : ""}`}
          style={eventTypeWrapStyle}
        >

          <div className="tab">
            <div className={`tab_list${tab === "Result" ? " result-tab" : ""}`}>
              <ul className="btn-group">
                <li
                  onClick={() => changeTab("play")}
                  className={`${tab === "play" ? "active" : ""} tab_list_item`}
                >
                  <a> In-Play </a>
                </li>
                <li
                  onClick={() => changeTab("today")}
                  className={`${tab === "today" ? "active" : ""} tab_list_item`}
                >
                  <a> Today </a>
                </li>
                <li
                  onClick={() => changeTab("tomorrow")}
                  className={`${tab === "tomorrow" ? "active" : ""} tab_list_item`}
                >
                  <a> Tomorrow </a>
                </li>
                <li
                  onClick={() => changeTab("Result")}
                  className={`${tab === "Result" ? "active" : ""} tab_list_item`}
                >
                  <a> Result </a>
                </li>
              </ul>
              {window.innerWidth < 993 && tab !== "Result" && (
                <a className="a-search" href="javascript:void(0)">
                  Search
                </a>
              )}
            </div>
          </div>

          {tab === "Result" ? (
            <CheckResults />
          ) : isLoading ? (
            <div className="loader_top loader_overlay">
              <div className="">
                <Loader />
              </div>
            </div>
          ) : (
            <>
              <div className="over-wrap">
                {/* // add close class for toggle on off in right side of col3 */}

                {activeFilter.cricket && (isLoading || pageData?.cricket?.length > 0) && (
                  <>
                    <div
                      className={`game-wrap col3 ${cricketToggle ? "close" : ""}`}
                    >
                      <h3 onClick={() => setCricketToggle(!cricketToggle)}>
                        <a id="eventType" className="to-expand">
                          Cricket
                        </a>
                      </h3>
                      <ul className="slip-head">
                        <li className="col-game"></li>
                        <li className="col-matched">{/* Matched */}</li>
                        <li className="col-visit">1</li>
                        <li className="col-draw">x</li>
                        <li className="col-home">2</li>
                        <li className="col-info"></li>
                      </ul>
                      <div className="game-list">
                        {pageData &&
                          !isLoading &&
                          pageData.cricket.length > 0 ? (
                          pageData.cricket.map(
                            (item: gameInterface, i: any) => {

                              return (
                                <>
                                  <dl className="game-list-col disabled">
                                    <dt id="eventInfo">
                                      <Link className='event-link'
                                        to={`/multimarket/${item.gameId}/${item.marketId}`}
                                        onClick={() => openMatchOdds(item)}
                                      >
                                        {window.innerWidth < 993 && (
                                          <>
                                            <div style={{ marginLeft: "17px" }}>
                                              <span
                                                className="game-live"
                                                id="streamingIcon"
                                                style={
                                                  showTvIcon(item)
                                                    ? {
                                                      display: "inline-flex",
                                                      marginRight: "5px",
                                                    }
                                                    : { display: "none" }
                                                }
                                              >
                                                Live
                                              </span>
                                              <span
                                                className={
                                                  item.inPlay
                                                    ? "game-fancy in-play"
                                                    : "game-fancy"
                                                }
                                                id="fancyBetIcon"
                                                style={
                                                  item.f
                                                    ? {
                                                      display: "inline-flex",
                                                      marginRight: "5px",
                                                    }
                                                    : { display: "none" }
                                                }
                                              >
                                                Fancy
                                              </span>
                                              <span
                                                className={
                                                  item.inPlay
                                                    ? "game-bookmaker in-play"
                                                    : "game-bookmaker"
                                                }
                                                id="bookMakerIcon"
                                                style={
                                                  item.m1
                                                    ? {
                                                      display: "inline-flex",
                                                      marginRight: "5px",
                                                    }
                                                    : { display: "none" }
                                                }
                                              >
                                                BookMaker
                                              </span>
                                              <span
                                                className="game-sportsbook"
                                                id="sportsBookIcon_2"
                                                style={
                                                  item.p || true
                                                    ? { display: "inline-flex" }
                                                    : { display: "none" }
                                                }
                                              >
                                                Premium Cricket
                                              </span>
                                              {item.inPlay && (
                                                <span className="in_play">
                                                  In-Play
                                                </span>
                                              )}
                                              {!item.inPlay && (
                                                <span
                                                  id="dateTimeInfo"
                                                  className="game-list-time"
                                                >
                                                  {moment(
                                                    item.openDate,
                                                  ).calendar()}
                                                </span>
                                              )}
                                              {item?.ematch > 0 && (
                                                <span
                                                  className="game-E"
                                                  id="sportsBookEIcon_4"
                                                >
                                                  <i></i>Cricket
                                                </span>
                                              )}
                                            </div>
                                          </>
                                        )}
                                        {/* <img id="playIcon" className="icon-in_play" style={!item.inPlay ? { backgroundColor: '#aeaeae', borderRadius: 10, backgroundImage: 'unset' } : {}} src="../../images/transparent.gif" alt="gif" /> */}
                                        <span
                                          id="lowLiquidityTag"
                                          className="game-low_liq"
                                          style={{ display: "none" }}
                                        >
                                          Low Liquidity
                                        </span>
                                        <a
                                          id="vsName"
                                          className={
                                            item.inPlay
                                              ? "active vsName"
                                              : "vsName"
                                          }
                                        >
                                          {item.eventName}
                                        </a>
                                        {window.innerWidth > 993 && (
                                          <>
                                            {!item.inPlay && (
                                              <span
                                                id="dateTimeInfo"
                                                className="game-list-time"
                                              >
                                                {moment(
                                                  item.openDate,
                                                ).calendar()}
                                              </span>
                                            )}
                                            {item.inPlay && (
                                              <span className="in_play">
                                                In-Play
                                              </span>
                                            )}
                                            <div
                                              style={{
                                                display: "inline-flex",
                                                verticalAlign: "middle",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <span
                                                className="game-live"
                                                id="streamingIcon"
                                                style={
                                                  showTvIcon(item)
                                                    ? {
                                                      display: "inline-flex",
                                                      margin: "0 2px",
                                                    }
                                                    : { display: "none" }
                                                }
                                              >
                                                Live
                                              </span>
                                              <span
                                                className={
                                                  item.inPlay
                                                    ? "game-fancy in-play"
                                                    : "game-fancy"
                                                }
                                                id="fancyBetIcon"
                                                style={
                                                  item.f
                                                    ? {
                                                      display: "inline-flex",
                                                      margin: "0 2px",
                                                    }
                                                    : { display: "none" }
                                                }
                                              >
                                                Fancy
                                              </span>
                                              <span
                                                className={
                                                  item.inPlay
                                                    ? "game-bookmaker in-play"
                                                    : "game-bookmaker"
                                                }
                                                id="bookMakerIcon"
                                                style={
                                                  item.m1
                                                    ? {
                                                      display: "inline-flex",
                                                      margin: "0 2px",
                                                    }
                                                    : { display: "none" }
                                                }
                                              >
                                                BookMaker
                                              </span>
                                              {item?.ematch > 0 && (
                                                <span
                                                  className="game-E"
                                                  id="sportsBookEIcon_4"
                                                >
                                                  <i></i>Cricket
                                                </span>
                                              )}
                                            </div>
                                          </>
                                        )}
                                      </Link>
                                    </dt>
                                    <dd id="matched" className="col-matched">
                                      {/* PTE29,484 */}
                                    </dd>
                                    <dd id="selectTemp" className="col-visit">
                                      <div
                                        className="suspend"
                                        style={{ display: "none" }}
                                      >
                                        <span>Suspend</span>
                                      </div>
                                      <a id="btnBack" className="btn-back">
                                        {item.back1}
                                      </a>
                                      <a id="btnLay" className="btn-lay">
                                        {item.lay1}
                                      </a>
                                    </dd>
                                    <dd className="col-draw">
                                      <div
                                        className="suspend"
                                        style={{ display: "none" }}
                                      >
                                        <span>Suspend</span>
                                      </div>
                                      <a id="btnBack" className="btn-back">
                                        {item.back2}
                                      </a>
                                      <a id="btnLay" className="btn-lay">
                                        {item.lay2}
                                      </a>
                                    </dd>
                                    <dd className="col-home">
                                      <div
                                        className="suspend"
                                        style={{ display: "none" }}
                                      >
                                        <span>Suspend</span>
                                      </div>
                                      <a id="btnBack" className="btn-back">
                                        {item.back3}
                                      </a>
                                      <a id="btnLay" className="btn-lay">
                                        {item.lay3}
                                      </a>
                                    </dd>
                                    <dd
                                      className="col-info"

                                    >
                                      <a
                                        id="multiMarketPin"
                                        className={`add-pin ${item?.pin ? "active" : ""}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) =>
                                          pinMetch(e, item, "cricket")
                                        }
                                        title="Add to Multi Markets"
                                      >
                                        Pin
                                      </a>
                                    </dd>
                                  </dl>
                                </>
                              );
                            },
                          )
                        ) : isLoading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              style={{ width: 100 }}
                              src={LoaderImage}
                              alt=""
                            />
                          </div>
                        ) : (
                          <h2 className="no-data">No data</h2>
                        )}
                      </div>
                    </div>

                    {showInplayCricketBanner && (
                      <div id="inplayVirtualCricketImage" className="footer-kv">
                        <a id="inplayVirtualCricketEntrance" className="entrance">
                          <img src={inplayCricketBannerSrc} alt="" />
                        </a>
                      </div>
                    )}
                  </>
                )}

                {activeFilter.soccer && (isLoading || pageData?.soccer?.length > 0) && (
                  <div
                    className={`game-wrap col3 ${soccerToggle ? "close" : ""}`}
                  >
                    <h3 onClick={() => setSoccerToggle(!soccerToggle)}>
                      <a id="eventType" className="to-expand">
                        Soccer
                      </a>
                    </h3>
                    <ul className="slip-head">
                      <li className="col-game"></li>
                      <li className="col-matched">{/* Matched */}</li>
                      <li className="col-visit">1</li>
                      <li className="col-draw">x</li>
                      <li className="col-home">2</li>
                      <li className="col-info"></li>
                    </ul>
                    <div className="game-list">
                      {pageData &&
                        !isLoading &&
                        pageData?.soccer?.length > 0 ? (
                        pageData?.soccer?.map((item: gameInterface, i: any) => {
                          return (
                            <>
                              <dl className="game-list-col disabled">
                                <dt id="eventInfo">
                                  <Link className='event-link'
                                    to={`/multimarket/${item.gameId}/${item.marketId}`}
                                    onClick={() => openMatchOdds(item)}
                                  >
                                    {window.innerWidth < 993 && (
                                      <>
                                        <div style={{ marginLeft: "17px" }}>
                                          <span
                                            className="game-live"
                                            id="streamingIcon"
                                            style={
                                              showTvIcon(item)
                                                ? {
                                                  display: "inline-flex",
                                                  marginRight: "5px",
                                                }
                                                : { display: "none" }
                                            }
                                          >
                                            Live
                                          </span>
                                          <span
                                            className={
                                              item.inPlay
                                                ? "game-fancy in-play"
                                                : "game-fancy"
                                            }
                                            id="fancyBetIcon"
                                            style={
                                              item.f
                                                ? {
                                                  display: "inline-flex",
                                                  marginRight: "5px",
                                                }
                                                : { display: "none" }
                                            }
                                          >
                                            Fancy
                                          </span>
                                          <span
                                            className={
                                              item.inPlay
                                                ? "game-bookmaker in-play"
                                                : "game-bookmaker"
                                            }
                                            id="bookMakerIcon"
                                            style={
                                              item.m1
                                                ? {
                                                  display: "inline-flex",
                                                  marginRight: "5px",
                                                }
                                                : { display: "none" }
                                            }
                                          >
                                            BookMaker
                                          </span>
                                          {item.inPlay && (
                                            <span className="in_play">
                                              In-Play
                                            </span>
                                          )}
                                          {!item.inPlay && (
                                            <span
                                              id="dateTimeInfo"
                                              className="game-list-time"
                                            >
                                              {moment(item.openDate).calendar()}
                                            </span>
                                          )}
                                          {item?.ematch > 0 && (
                                            <span
                                              className="game-E"
                                              id="sportsBookEIcon_137"
                                            >
                                              <i></i>e-Soccer
                                            </span>
                                          )}
                                        </div>
                                      </>
                                    )}
                                    {/* <img id="playIcon" className="icon-in_play" src="../../images/transparent.gif" alt="gif" /> */}
                                    <span
                                      id="lowLiquidityTag"
                                      className="game-low_liq"
                                      style={{ display: "none" }}
                                    >
                                      Low Liquidity
                                    </span>
                                    <a
                                      id="vsName"
                                      className={
                                        item.inPlay ? "active vsName" : "vsName"
                                      }
                                    >
                                      {eventTitleWithScore(item, soccerSport)}
                                    </a>
                                    {/* <span id="dateTimeInfo" className="game-list-time"><span className="in_play">{item.inPlay ? 'In-Play' : ''}</span></span>
                                                    <span className="game-live" id="streamingIcon" style={showTvIcon(item) ? { display: "inline-flex" } : { display: "none" }} >Live</span>
                                                    <span className="game-fancy in-play" id="fancyBetIcon" style={item.f ? { display: "inline-flex" } : { display: "none" }}>Fancy</span>
                                                    <span className="game-bookmaker in-play" id="bookMakerIcon" style={item.m1 ? { display: "inline-flex" } : { display: "none" }}>BookMaker</span> */}
                                    {window.innerWidth > 993 && (
                                      <>
                                        {!item.inPlay && (
                                          <span
                                            id="dateTimeInfo"
                                            className="game-list-time"
                                          >
                                            {moment(item.openDate).calendar()}
                                          </span>
                                        )}
                                        {item.inPlay && (
                                          <span className="in_play">
                                            In-Play
                                          </span>
                                        )}
                                        <div
                                          style={{
                                            display: "inline-flex",
                                            verticalAlign: "middle",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <span
                                            className="game-live"
                                            id="streamingIcon"
                                            style={
                                              showTvIcon(item)
                                                ? {
                                                  display: "inline-flex",
                                                  marginRight: "5px",
                                                }
                                                : { display: "none" }
                                            }
                                          >
                                            Live
                                          </span>
                                          <span
                                            className={
                                              item.inPlay
                                                ? "game-fancy in-play"
                                                : "game-fancy"
                                            }
                                            id="fancyBetIcon"
                                            style={
                                              item.f
                                                ? {
                                                  display: "inline-flex",
                                                  marginRight: "5px",
                                                }
                                                : { display: "none" }
                                            }
                                          >
                                            Fancy
                                          </span>
                                          <span
                                            className={
                                              item.inPlay
                                                ? "game-bookmaker in-play"
                                                : "game-bookmaker"
                                            }
                                            id="bookMakerIcon"
                                            style={
                                              item.m1
                                                ? {
                                                  display: "inline-flex",
                                                  marginRight: "5px",
                                                }
                                                : { display: "none" }
                                            }
                                          >
                                            BookMaker
                                          </span>
                                          {item?.ematch > 0 && (
                                            <span
                                              className="game-E"
                                              id="sportsBookEIcon_137"
                                            >
                                              <i></i>e-Soccer
                                            </span>
                                          )}
                                        </div>
                                      </>
                                    )}
                                  </Link>
                                </dt>
                                <dd id="matched" className="col-matched">
                                  {/* PTE29,484 */}
                                </dd>
                                <dd id="selectTemp" className="col-visit">
                                  <div
                                    className="suspend"
                                    style={{ display: "none" }}
                                  >
                                    <span>Suspend</span>
                                  </div>
                                  <a id="btnBack" className="btn-back">
                                    {item.back1}
                                  </a>
                                  <a id="btnLay" className="btn-lay">
                                    {item.lay1}
                                  </a>
                                </dd>
                                <dd className="col-draw">
                                  <div
                                    className="suspend"
                                    style={{ display: "none" }}
                                  >
                                    <span>Suspend</span>
                                  </div>
                                  <a id="btnBack" className="btn-back">
                                    {item.back2}
                                  </a>
                                  <a id="btnLay" className="btn-lay">
                                    {item.lay2}
                                  </a>
                                </dd>
                                <dd className="col-home">
                                  <div
                                    className="suspend"
                                    style={{ display: "none" }}
                                  >
                                    <span>Suspend</span>
                                  </div>
                                  <a id="btnBack" className="btn-back">
                                    {item.back3}
                                  </a>
                                  <a id="btnLay" className="btn-lay">
                                    {item.lay3}
                                  </a>
                                </dd>
                                <dd className="col-info">
                                  <a
                                    id="multiMarketPin"
                                    className={`add-pin ${item?.pin ? "active" : ""}`}
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => pinMetch(e, item, "soccer")}
                                    title="Add to Multi Markets"
                                  >
                                    Pin
                                  </a>
                                </dd>
                              </dl>
                            </>
                          );
                        })
                      ) : isLoading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            style={{ width: 100 }}
                            src={LoaderImage}
                            alt=""
                          />
                        </div>
                      ) : (
                        <h2 className="no-data">No data</h2>
                      )}
                    </div>
                  </div>
                )}

                {activeFilter.tennis && (isLoading || pageData?.tennis?.length > 0) && (
                  <div
                    className={`game-wrap col3 ${tennisToggle ? "close" : ""}`}
                  >
                    <h3 onClick={() => setTennisToggle(!tennisToggle)}>
                      <a id="eventType" className="to-expand">
                        Tennis
                      </a>
                    </h3>
                    <ul className="slip-head">
                      <li
                        className="col-game"
                        style={{ width: "calc(63.8% - 14px)" }}
                      ></li>
                      <li className="col-matched">{/* Matched */}</li>
                      <li className="col-visit">1</li>
                      <li className="col-draw">x</li>
                      <li className="col-home">2</li>
                      <li className="col-info"></li>
                    </ul>
                    <div className="game-list">
                      {pageData &&
                        !isLoading &&
                        pageData?.tennis?.length > 0 ? (
                        pageData?.tennis?.map((item: gameInterface, i: any) => {
                          return (
                            <>
                              <dl className="game-list-col disabled">
                                <dt
                                  id="eventInfo"
                                  style={{ width: "calc(63.8% - 14px)" }}
                                >
                                  <Link className='event-link'
                                    to={`/multimarket/${item.gameId}/${item.marketId}`}
                                    onClick={() => openMatchOdds(item)}
                                  >
                                    {window.innerWidth < 993 && (
                                      <>
                                        <div style={{ marginLeft: "17px" }}>
                                          <span
                                            className="game-live"
                                            id="streamingIcon"
                                            style={
                                              showTvIcon(item)
                                                ? {
                                                  display: "inline-flex",
                                                  marginRight: "5px",
                                                }
                                                : { display: "none" }
                                            }
                                          >
                                            Live
                                          </span>
                                          <span
                                            className={
                                              item.inPlay
                                                ? "game-fancy in-play"
                                                : "game-fancy"
                                            }
                                            id="fancyBetIcon"
                                            style={
                                              item.f
                                                ? {
                                                  display: "inline-flex",
                                                  marginRight: "5px",
                                                }
                                                : { display: "none" }
                                            }
                                          >
                                            Fancy
                                          </span>
                                          <span
                                            className={
                                              item.inPlay
                                                ? "game-bookmaker in-play"
                                                : "game-bookmaker"
                                            }
                                            id="bookMakerIcon"
                                            style={
                                              item.m1
                                                ? {
                                                  display: "inline-flex",
                                                  marginRight: "5px",
                                                }
                                                : { display: "none" }
                                            }
                                          >
                                            BookMaker
                                          </span>
                                          {item.inPlay && (
                                            <span className="in_play">
                                              In-Play
                                            </span>
                                          )}
                                          {
                                            <span
                                              id="dateTimeInfo"
                                              className="game-list-time"
                                            >
                                              {!item.inPlay &&
                                                moment(
                                                  item.openDate,
                                                ).calendar()}
                                            </span>
                                          }
                                          {item?.ematch > 0 && (
                                            <span
                                              className="game-E"
                                              id="sportsBookEIcon_2"
                                            >
                                              <i></i>Tennis
                                            </span>
                                          )}
                                        </div>
                                      </>
                                    )}
                                    {/* <img id="playIcon" className="icon-in_play" src="../../images/transparent.gif" alt="gif" /> */}
                                    <span
                                      id="lowLiquidityTag"
                                      className="game-low_liq"
                                      style={{ display: "none" }}
                                    >
                                      Low Liquidity
                                    </span>
                                    <a
                                      id="vsName"
                                      className={
                                        item.inPlay ? "active vsName" : "vsName"
                                      }
                                    >
                                      {eventTitleWithScore(item, tennisSport)}
                                    </a>
                                    {window.innerWidth > 993 && (
                                      <>
                                        {!item.inPlay && (
                                          <span
                                            id="dateTimeInfo"
                                            className="game-list-time"
                                          >
                                            {moment(item.openDate).calendar()}
                                          </span>
                                        )}
                                        {item.inPlay && (
                                          <span className="in_play">
                                            In-Play
                                          </span>
                                        )}
                                        <span
                                          className="game-live"
                                          id="streamingIcon"
                                          style={
                                            showTvIcon(item)
                                              ? { display: "inline-flex" }
                                              : { display: "none" }
                                          }
                                        >
                                          Live
                                        </span>
                                        <span
                                          className={
                                            item.inPlay
                                              ? "game-fancy in-play"
                                              : "game-fancy"
                                          }
                                          id="fancyBetIcon"
                                          style={
                                            item.f
                                              ? { display: "inline-flex" }
                                              : { display: "none" }
                                          }
                                        >
                                          Fancy
                                        </span>
                                        <span
                                          className={
                                            item.inPlay
                                              ? "game-bookmaker in-play"
                                              : "game-bookmaker"
                                          }
                                          id="bookMakerIcon"
                                          style={
                                            item.m1
                                              ? { display: "inline-flex" }
                                              : { display: "none" }
                                          }
                                        >
                                          BookMaker
                                        </span>
                                        {item?.ematch > 0 && (
                                          <span
                                            className="game-E"
                                            id="sportsBookEIcon_2"
                                          >
                                            <i></i>Tennis
                                          </span>
                                        )}
                                      </>
                                    )}
                                    {/* <span id="dateTimeInfo" className="game-list-time"><span className="in_play">{item.inPlay ? 'In-Play' : ''}</span></span>
                                                        <span className="game-live" id="streamingIcon" style={showTvIcon(item) ? { display: "inline-flex" } : { display: "none" }} >Live</span>
                                                        <span className="game-fancy in-play" id="fancyBetIcon" style={item.f ? { display: "inline-flex" } : { display: "none" }}>Fancy</span>
                                                        <span className="game-bookmaker in-play" id="bookMakerIcon" style={item.m1 ? { display: "inline-flex" } : { display: "none" }}>BookMaker</span> */}
                                  </Link>
                                </dt>
                                <dd id="matched" className="col-matched">
                                  {/* PTE29,484 */}
                                </dd>
                                <dd id="selectTemp" className="col-visit">
                                  <div
                                    className="suspend"
                                    style={{ display: "none" }}
                                  >
                                    <span>Suspend</span>
                                  </div>
                                  <a id="btnBack" className="btn-back">
                                    {item.back1}
                                  </a>
                                  <a id="btnLay" className="btn-lay">
                                    {item.lay1}
                                  </a>
                                </dd>
                                <dd className="col-draw">
                                  <div
                                    className="suspend"
                                    style={{ display: "none" }}
                                  >
                                    <span>Suspend</span>
                                  </div>
                                  <a id="btnBack" className="btn-back">
                                    {item.back2}
                                  </a>
                                  <a id="btnLay" className="btn-lay">
                                    {item.lay2}
                                  </a>
                                </dd>
                                <dd className="col-home">
                                  <div
                                    className="suspend"
                                    style={{ display: "none" }}
                                  >
                                    <span>Suspend</span>
                                  </div>
                                  <a id="btnBack" className="btn-back">
                                    {item.back3}
                                  </a>
                                  <a id="btnLay" className="btn-lay">
                                    {item.lay3}
                                  </a>
                                </dd>
                                {/* {console.log("flag", item.flag)} */}

                                <dd className="col-info">
                                  <a
                                    id="multiMarketPin"
                                    className={`add-pin ${item?.pin ? "active" : ""}`}
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => pinMetch(e, item, "tennis")}
                                    title="Add to Multi Markets"
                                  >
                                    Pin
                                  </a>
                                </dd>
                              </dl>
                            </>
                          );
                        })
                      ) : isLoading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            style={{ width: 100 }}
                            src={LoaderImage}
                            alt=""
                          />
                        </div>
                      ) : isLoading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            style={{ width: 100 }}
                            src={LoaderImage}
                            alt=""
                          />
                        </div>
                      ) : (
                        <h2 className="no-data">No data</h2>
                      )}
                    </div>
                  </div>
                )}
                {window.innerWidth < 993 ? (
                  <div className="mb-50 hight-10"></div>
                ) : (
                  ""
                )}
              </div>
            </>
          )}

          {!isLoading &&
            window.innerWidth > 992 &&
            (tab === "tomorrow" || tab === "today" || tab === "play") && (
              <div className="tab_content">
                <div className="today_tab">
                  <div className="sports_filters">
                    <div className="sports_filters_left">
                      <h5>Sports Filters:</h5>
                      <ul className="d-flex align-items-center">
                        {activeFilter.cricket && <li>Cricket</li>}
                        {activeFilter.soccer && <li>Soccer</li>}
                        {activeFilter.tennis && <li>Tennis</li>}
                        {!activeFilter.cricket &&
                          !activeFilter.soccer &&
                          !activeFilter.tennis && <li>None</li>}
                      </ul>
                    </div>
                    <div className="sports_filters_right">
                      <button
                        type="button"
                        className="close_btn btn btn-primary"
                        onClick={toggleFilterOpen}
                      >
                        Filter
                      </button>
                      {filterOpen && (
                        <>
                          <div className="tooltip_modal">
                            <div
                              className="popover-arrow"
                              style={{ position: "absolute", right: "50px" }}
                            ></div>
                            <div className="popover-body">
                              <div className="container">
                                <form
                                  className="filter_menu"
                                  onSubmit={(e) => e.preventDefault()}
                                >
                                  <div className="filter_menu_wrp">
                                    <div className="filter_menu_wrp_top">
                                      <div className="filter_menu_wrp_left">
                                        <div>
                                          <div className="mb-0">
                                            <div className="form-check">
                                              <input
                                                type="checkbox"
                                                id="formBasicCheckboxAll"
                                                className="form-check-input"
                                                checked={isAllTempChecked}
                                                disabled={isAllTempChecked}
                                                onChange={handleSelectAll}
                                              />
                                              <label
                                                title=""
                                                htmlFor="formBasicCheckboxAll"
                                                className="form-check-label"
                                                style={{ cursor: "pointer" }}
                                              >
                                                All
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div>
                                          <div className="mb-0">
                                            <div className="form-check">
                                              <input
                                                type="checkbox"
                                                id="formBasicCheckboxTennis"
                                                className="form-check-input"
                                                checked={tempFilter.tennis}
                                                disabled={
                                                  tempFilter.tennis &&
                                                  tempActiveCount === 1
                                                }
                                                onChange={(e) => {
                                                  if (
                                                    !e.target.checked &&
                                                    tempActiveCount <= 1
                                                  )
                                                    return;
                                                  setTempFilter((prev) => ({
                                                    ...prev,
                                                    tennis: e.target.checked,
                                                  }));
                                                }}
                                              />
                                              <label
                                                title=""
                                                htmlFor="formBasicCheckboxTennis"
                                                className="form-check-label"
                                                style={{ cursor: "pointer" }}
                                              >
                                                Tennis
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="filter_menu_wrp_right">
                                        <div>
                                          <div className="mb-0">
                                            <div className="form-check">
                                              <input
                                                type="checkbox"
                                                id="formBasicCheckboxSoccer"
                                                className="form-check-input"
                                                checked={tempFilter.soccer}
                                                disabled={
                                                  tempFilter.soccer &&
                                                  tempActiveCount === 1
                                                }
                                                onChange={(e) => {
                                                  if (
                                                    !e.target.checked &&
                                                    tempActiveCount <= 1
                                                  )
                                                    return;
                                                  setTempFilter((prev) => ({
                                                    ...prev,
                                                    soccer: e.target.checked,
                                                  }));
                                                }}
                                              />
                                              <label
                                                title=""
                                                htmlFor="formBasicCheckboxSoccer"
                                                className="form-check-label"
                                                style={{ cursor: "pointer" }}
                                              >
                                                Soccer
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div>
                                          <div className="mb-0">
                                            <div className="form-check">
                                              <input
                                                type="checkbox"
                                                id="formBasicCheckboxCricket"
                                                className="form-check-input"
                                                checked={tempFilter.cricket}
                                                disabled={
                                                  tempFilter.cricket &&
                                                  tempActiveCount === 1
                                                }
                                                onChange={(e) => {
                                                  if (
                                                    !e.target.checked &&
                                                    tempActiveCount <= 1
                                                  )
                                                    return;
                                                  setTempFilter((prev) => ({
                                                    ...prev,
                                                    cricket: e.target.checked,
                                                  }));
                                                }}
                                              />
                                              <label
                                                title=""
                                                htmlFor="formBasicCheckboxCricket"
                                                className="form-check-label"
                                                style={{ cursor: "pointer" }}
                                              >
                                                Cricket
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <ul className="filter_menu_wrp_bottom btn-wrap">
                                      <li className="col-send">
                                        <button
                                          type="button"
                                          className="btn-send m-0 btn btn-primary"
                                          onClick={handleSaveFilter}
                                        >
                                          Save
                                        </button>
                                      </li>
                                      <li className=" me-4">
                                        <button
                                          type="button"
                                          className="btn btn btn-primary"
                                          onClick={handleCancelFilter}
                                        >
                                          Cancel{" "}
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {(tab === "today" || tab === "tomorrow") && (
                  <div className="game-list today_table">
                    {activeFilter.cricket &&
                      pageData?.cricket?.length > 0 &&
                      pageData?.cricket.map((item: gameInterface, i: any) => {
                        return (
                          <dl className="game-list-col" key={i}>
                            <dt>
                              {/* {tab === "today" ? "today" : " Tomorrow"} */}
                              {moment(
                                item.openDate,
                                "YYYY-MM-DD HH:mm",
                              ).format("hh:mm A")}
                            </dt>
                            <dt>
                              <div className="table_data">
                                <h5>
                                  Cricket
                                  <span className="angle_unicode">▸</span>
                                  <a
                                    href={`/multimarket/${item.gameId}/${item.marketId}`}
                                    onClick={(e) => openMatchOdds(item, e)}
                                  >
                                    {item.eventName}
                                  </a>
                                </h5>
                              </div>
                            </dt>
                          </dl>
                        );
                      })}

                    {activeFilter.soccer &&
                      pageData?.soccer?.length > 0 &&
                      pageData?.soccer.map((item: gameInterface, i: any) => {
                        return (
                          <dl className="game-list-col" key={i}>
                            <dt>
                              {/* {tab === "today" ? "today" : " Tomorrow"} */}
                              {moment(
                                item.openDate,
                                "YYYY-MM-DD HH:mm",
                              ).format("hh:mm A")}
                            </dt>
                            <dt>
                              <div className="table_data">
                                <h5>
                                  {" "}
                                  Soccer
                                  <span className="angle_unicode">▸</span>
                                  <a
                                    href={`/multimarket/${item.gameId}/${item.marketId}`}
                                    onClick={(e) => openMatchOdds(item, e)}
                                  >
                                    {eventTitleWithScore(item, soccerSport)}
                                  </a>
                                </h5>
                              </div>
                            </dt>
                          </dl>
                        );
                      })}

                    {activeFilter.tennis &&
                      pageData?.tennis?.length > 0 &&
                      pageData?.tennis.map((item: gameInterface, i: any) => {
                        return (
                          <dl className="game-list-col" key={i}>
                            <dt>
                              {/* {tab === "today" ? "today" : " Tomorrow"} */}
                              {moment(
                                item.openDate,
                                "YYYY-MM-DD HH:mm",
                              ).format("hh:mm A")}
                            </dt>
                            <dt>
                              <div className="table_data">
                                <h5>
                                  Tennis
                                  <span className="angle_unicode">▸</span>
                                  <a
                                    href={`/multimarket/${item.gameId}/${item.marketId}`}
                                    onClick={(e) => openMatchOdds(item, e)}
                                  >
                                    {eventTitleWithScore(item, tennisSport)}
                                  </a>
                                </h5>
                              </div>
                            </dt>
                          </dl>
                        );
                      })}

                    {(!activeFilter.cricket || !pageData?.cricket?.length) &&
                      (!activeFilter.soccer || !pageData?.soccer?.length) &&
                      (!activeFilter.tennis || !pageData?.tennis?.length) && (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <h2 className="no-data">No data</h2>
                        </div>
                      )}
                  </div>
                )}
              </div>
            )}
        </div>

        <div className="inplay_right col-right">
          <div className="slip-wrap no-open-bet_slip">
            <h3>
              <a className="to-expand">Bet Slip </a>
            </h3>
            <ul id="loadingMsg" className="loading" style={{ display: "none" }}>
              <li>
                <span />
              </li>
              <li id="countDownTime">Place Bets </li>
            </ul>

            <p id="noBetSlipInfo">
              Click on the odds to add selections to the betslip.{" "}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Inplay;
